<div class="container mx-auto px-4 py-6">
  <!-- En-tête avec titre et actions -->
  <div class="bg-white rounded-lg shadow-sm mb-6 p-4">
    <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 items-stretch sm:items-center">
      <!-- Barre de recherche -->
      <div class="relative flex-1 sm:max-w-md">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
          [placeholder]="t('lots.searchPlaceholder')"
          class="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition text-sm bg-white">
      </div>

      <!-- Filtre Statut -->
      <div class="relative w-full sm:w-48">
        <select [(ngModel)]="selectedStatus" (ngModelChange)="onStatusChange()"
          class="w-full h-11 px-4 pr-10 bg-white border border-gray-300 rounded-lg text-sm text-gray-600 appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
          <option value="">{{ t('lots.allStatus') }}</option>
          <option value="IN_PROGRESS">{{ t('lots.status.IN_PROGRESS') }}</option>
          <option value="COMPLETED">{{ t('lots.status.COMPLETED') }}</option>
          <option value="PENDING">{{ t('lots.status.PENDING') }}</option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Bouton Nouveau Lot -->
      <div class="ml-auto">
        <button (click)="openCreateModal()"
          class="h-11 px-6 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-xl flex items-center gap-2 transition-colors whitespace-nowrap shadow-sm">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.85714 9.14286H1.14286C0.819051 9.14286 0.547813 9.03314 0.329147 8.81371C0.11048 8.59429 0.000765845 8.32305 3.94088e-06 8C-0.000757964 7.67695 0.108956 7.40571 0.329147 7.18629C0.549337 6.96686 0.820575 6.85714 1.14286 6.85714H6.85714V1.14286C6.85714 0.819051 6.96686 0.547813 7.18629 0.329147C7.40571 0.11048 7.67695 0.000765845 8 3.94088e-06C8.32305 -0.000757964 8.59467 0.108956 8.81486 0.329147C9.03505 0.549337 9.14438 0.820575 9.14286 1.14286V6.85714H14.8571C15.1809 6.85714 15.4526 6.96686 15.672 7.18629C15.8914 7.40571 16.0008 7.67695 16 8C15.9992 8.32305 15.8895 8.59467 15.6709 8.81486C15.4522 9.03505 15.1809 9.14438 14.8571 9.14286H9.14286V14.8571C9.14286 15.1809 9.03314 15.4526 8.81371 15.672C8.59429 15.8914 8.32305 16.0008 8 16C7.67695 15.9992 7.40571 15.8895 7.18629 15.6709C6.96686 15.4522 6.85714 15.1809 6.85714 14.8571V9.14286Z"
              fill="white" />
          </svg>
          <span class="hidden sm:inline">{{ t('lots.newLot') }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Messages -->
  <div *ngIf="errorMessage" class="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">
    {{ errorMessage }}
  </div>

  <!-- Chargement -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
  </div>

  <!-- Grille des lots optimisée -->
  <div *ngIf="!isLoading && filteredLots.length > 0">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      <div *ngFor="let lot of filteredLots"
        class="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition-all duration-200 overflow-hidden flex flex-col"
        style="max-width: 380px;">

        <!-- En-tête avec badge -->
        <div class="p-5 relative">
          <div class="absolute top-4 right-4">
            <span class="bg-[#2C3E50] text-white px-3 py-1 rounded-md text-xs font-semibold">
              Lot {{ lot.id }}
            </span>
          </div>
          <h3 class="text-xl font-bold text-gray-900 pr-20 mb-2">{{ lot.nom }}</h3>
          <p class="text-sm text-gray-500 line-clamp-2">{{ lot.description }}</p>
        </div>

        <!-- Dates alignées -->
        <div class="px-5 pb-3 grid grid-cols-2 gap-4 text-sm">
          <div>
            <div class="text-gray-500 text-xs mb-1">Date prévue</div>
            <div class="font-semibold text-gray-900">{{ lot.dateDebut }}</div>
          </div>
          <div>
            <div class="text-gray-500 text-xs mb-1">Fin prévue</div>
            <div class="font-semibold text-gray-900">{{ lot.dateFin }}</div>
          </div>
        </div>

        <!-- Statut et progression -->
        <div class="px-5 pb-3">
          <div class="flex justify-between items-center mb-2">
            <div class="relative">
              <button (click)="toggleStatusDropdown(lot.id, $event)"
                [class]="lot.statutColor + ' cursor-pointer hover:opacity-80 transition-opacity flex items-center gap-1'">
                {{ t('lots.status.' + lot.statut) }}
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <!-- Dropdown des statuts -->
              <div *ngIf="showStatusDropdown === lot.id"
                class="absolute z-50 mt-1 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1"
                (click)="$event.stopPropagation()">
                <button *ngFor="let status of availableStatuses" (click)="changeStatus(lot.id, status.value, $event)"
                  [class]="status.color + ' w-full text-left px-3 py-2 text-xs font-medium hover:bg-gray-50 transition-colors'"
                  [disabled]="getStatusAPIValue(lot.statut) === status.value">
                  {{ t('lots.status.' + status.value) }}
                  <span *ngIf="getStatusAPIValue(lot.statut) === status.value" class="ml-1">✓</span>
                </button>
              </div>
            </div>

            <!-- Pourcentage avec icône d'édition -->
            <div class="flex items-center gap-2">
              <span class="text-lg font-bold text-gray-900">{{ lot.progression }}%</span>
              <button (click)="openProgressModal(lot.id, lot.progression)"
                class="text-orange-600 hover:text-orange-700 transition-colors p-1 rounded hover:bg-orange-50"
                title="Modifier la progression">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Barre de progression orange -->
          <div class="w-full h-2.5 bg-gray-200 rounded-full overflow-hidden">
            <div [style.width.%]="lot.progression" class="h-full transition-all duration-300 rounded-full bg-[#FF5C02]">
            </div>
          </div>
        </div>

        <!-- Section Intervenant -->
        <div class="px-5 pb-4">
          <div class="flex items-center gap-3 bg-gray-50 rounded-lg p-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 15C7.58 15 4 16.79 4 19V21H20V19C20 16.79 16.42 15 12 15ZM8 9C8 10.0609 8.42143 11.0783 9.17157 11.8284C9.92172 12.5786 10.9391 13 12 13C13.0609 13 14.0783 12.5786 14.8284 11.8284C15.5786 11.0783 16 10.0609 16 9M11.5 2C11.2 2 11 2.21 11 2.5V5.5H10V3C10 3 7.75 3.86 7.75 6.75C7.75 6.75 7 6.89 7 8H17C16.95 6.89 16.25 6.75 16.25 6.75C16.25 3.86 14 3 14 3V5.5H13V2.5C13 2.21 12.81 2 12.5 2H11.5Z"
                fill="#FF5C02" />
            </svg>

            <div class="flex-1 min-w-0">
              <div class="font-semibold text-gray-900 text-sm truncate"
                [title]="lot.soustraitant?.nom || t('common.unassigned')">
                {{ lot.soustraitant?.nom || t('common.unassigned') }}
              </div>
              <div class="text-xs text-gray-500 truncate" [title]="lot.soustraitant?.company || ''">
                {{ lot.soustraitant?.company || '' }}
              </div>
              <div *ngIf="lot.soustraitant?.telephone" class="text-xs text-orange-600 font-medium mt-0.5">
                {{ lot.soustraitant?.telephone }}
              </div>
            </div>
          </div>
        </div>

        <!-- Actions en bas -->
        <div class="px-5 pb-4 grid grid-cols-4 gap-2 border-t border-gray-100 pt-4">
          <!-- Modifier -->
          <button (click)="modifierLot(lot.id)"
            class="text-orange-600 hover:text-orange-700 flex flex-col items-center gap-1 text-xs font-medium transition-colors"
            title="Modifier">
            <svg class="h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8"
                stroke="#FF5C02" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12.2504 1.75015C12.5156 1.48493 12.8753 1.33594 13.2504 1.33594C13.6255 1.33594 13.9852 1.48493 14.2504 1.75015C14.5156 2.01537 14.6646 2.37508 14.6646 2.75015C14.6646 3.12522 14.5156 3.48493 14.2504 3.75015L8.24172 9.75948C8.08342 9.91765 7.88786 10.0334 7.67305 10.0962L5.75772 10.6562C5.70036 10.6729 5.63955 10.6739 5.58166 10.6591C5.52377 10.6442 5.47094 10.6141 5.42869 10.5719C5.38643 10.5296 5.35631 10.4768 5.34148 10.4189C5.32665 10.361 5.32766 10.3002 5.34439 10.2428L5.90439 8.32748C5.96741 8.11285 6.08341 7.91752 6.24172 7.75948L12.2504 1.75015Z"
                stroke="#FF5C02" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="hidden sm:inline">Modifier</span>
          </button>

          <!-- Voir Détails -->
          <button (click)="voirDocuments(lot.id)"
            class="text-orange-600 hover:text-orange-700 flex flex-col items-center gap-1 text-xs font-medium transition-colors"
            title="Voir détails">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <span class="hidden sm:inline text-[10px]">Détails</span>
          </button>

          <!-- Documents (Upload) -->
          <button (click)="openDocumentUpload(lot.id)"
            class="text-orange-600 hover:text-orange-700 flex flex-col items-center gap-1 text-xs font-medium transition-colors"
            title="Ajouter un document">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span class="hidden sm:inline text-[10px]">Docs</span>
          </button>

          <!-- Commentaires -->
          <button (click)="voirCommentaires(lot.id)"
            class="text-orange-600 hover:text-orange-700 flex flex-col items-center gap-1 text-xs font-medium transition-colors"
            title="Commentaires">
            <div class="relative">
              <svg class="h-6 w-6" width="24" height="24" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.66699 5.5C7.48833 5.5 5.66699 7.11267 5.66699 9.16667C5.66699 11.2207 7.48833 12.8333 9.66699 12.8333C10.165 12.8339 10.6593 12.7487 11.1283 12.5813L12.8723 13.308C12.93 13.3319 12.9932 13.3392 13.0547 13.329C13.1163 13.3188 13.1738 13.2915 13.2206 13.2502C13.2674 13.209 13.3017 13.1554 13.3196 13.0956C13.3374 13.0358 13.3382 12.9722 13.3217 12.912L12.8923 11.3367C13.3914 10.7233 13.6648 9.95736 13.667 9.16667C13.667 7.11267 11.8457 5.5 9.66699 5.5Z"
                  fill="#FF5C02" />
                <path
                  d="M2.66699 6.33333C2.66699 7.124 2.96966 7.85067 3.47633 8.422L3.14366 9.64067C3.09766 9.80933 3.07499 9.894 3.09699 9.94733C3.11699 9.994 3.15699 10.0287 3.20566 10.042C3.26166 10.058 3.34233 10.024 3.50366 9.95667L4.86633 9.38933C4.91299 9.408 4.96077 9.42578 5.00966 9.44267C5.00337 9.3508 5.00026 9.25875 5.00033 9.16667C5.00033 6.70533 7.14766 4.862 9.60899 4.83333C9.00566 3.74667 7.76566 3 6.33366 3C4.30833 3 2.66699 4.49267 2.66699 6.33333Z"
                  fill="#FF5C02" />
              </svg>
              <span *ngIf="(commentCounts.get(lot.id) || 0) > 0"
                class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full h-4 w-4 flex items-center justify-center font-bold border border-white">
                {{ commentCounts.get(lot.id) }}
              </span>
            </div>
            <span class="hidden sm:inline text-[10px]">Comm.</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Message aucun résultat -->
  <div *ngIf="!isLoading && filteredLots.length === 0" class="text-center py-20">
    <div class="mx-auto w-24 h-24 text-gray-400 mb-6">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
        </path>
      </svg>
    </div>
    <h3 class="text-xl font-medium text-gray-900 mb-2">
      {{ lots.length === 0 ? t('lots.noLots') : t('lots.noLotsFiltered') }}
    </h3>
    <p class="text-gray-600 mb-6">
      {{ lots.length === 0 ? t('lots.createFirstLot') : t('lots.adjustFilters') }}
    </p>
  </div>

  <!-- Pagination -->
  <div *ngIf="totalPages > 1 && !isLoading" class="mt-8 flex justify-center">
    <nav class="flex items-center gap-2">
      <button (click)="previousPage()" [disabled]="currentPage === 0"
        class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium disabled:opacity-50">
        {{ t('common.previous') }}
      </button>

      <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
        [class.bg-orange-500]="page === currentPage" [class.text-white]="page === currentPage"
        [class.border-orange-500]="page === currentPage"
        class="px-4 py-2 border rounded-lg text-sm font-medium hover:bg-orange-50 transition-colors">
        {{ page + 1 }}
      </button>

      <button (click)="nextPage()" [disabled]="currentPage === totalPages - 1"
        class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium disabled:opacity-50">
        {{ t('common.next') }}
      </button>
    </nav>
  </div>

  <!-- MODAL CRÉATION / MODIFICATION -->
  <div *ngIf="showCreateModal || showEditModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">

      <!-- Header -->
      <div class="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
        <div class="flex items-center gap-3">
          <h3 class="text-xl font-bold text-gray-900">
            <span *ngIf="showEditModal && currentLot.id">Lot {{ currentLot.id }} - </span>{{ showCreateModal ?
            t('lots.newLot') : currentLot.name }}
          </h3>
          <span *ngIf="showEditModal"
            class="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-xs font-semibold">
            En cours
          </span>
        </div>
        <button (click)="closeModal()" class="text-gray-500 hover:text-gray-700">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6">
        <!-- Messages -->
        <div *ngIf="errorMessage" class="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
          {{ errorMessage }}
        </div>

        <!-- Formulaire -->
        <div class="space-y-5">
          <!-- Désignation du lot -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('lots.modal.designation') }}</label>
            <input [(ngModel)]="currentLot.name"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
              placeholder="Gros œuvre">
          </div>

          <!-- Description -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('lots.modal.description') }}</label>
            <textarea [(ngModel)]="currentLot.description" [placeholder]="t('lots.modal.descriptionPlaceholder')"
              rows="3"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none resize-none"></textarea>
          </div>

          <!-- Dates -->
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('lots.modal.startDate') }}</label>
              <input type="date" [(ngModel)]="currentLot.startDate"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('lots.modal.endDate') }}</label>
              <input type="date" [(ngModel)]="currentLot.endDate"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none">
            </div>
          </div>

          <!-- Affecter un sous-traitant -->
          <div class="relative">
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ t('lots.modal.assignSubcontractor')
              }}</label>
            <input type="text" [(ngModel)]="subcontractorSearch" (input)="filterSubcontractors()"
              (focus)="showSubcontractorDropdown = true"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none pr-10"
              [placeholder]="t('lots.modal.subcontractorPlaceholder')">

            <svg class="absolute right-3 top-10 w-5 h-5 text-gray-400" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>

            <!-- Dropdown -->
            <div *ngIf="showSubcontractorDropdown"
              class="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
              <div *ngFor="let sub of filteredSubcontractors" (click)="selectSubcontractor(sub)"
                class="px-4 py-3 hover:bg-orange-50 cursor-pointer border-b last:border-b-0">
                <div class="font-medium">{{ sub.name }}</div>
                <div class="text-sm text-gray-500">{{ sub.company }} • {{ sub.phone }}</div>
              </div>

              <div *ngIf="filteredSubcontractors.length === 0 && subcontractorSearch"
                class="p-4 text-center text-gray-500 text-sm">
                {{ t('lots.noSubcontractorFound') }}
              </div>
            </div>
          </div>

          <!-- Sous-traitant sélectionné -->
          <div *ngIf="currentLot.subcontractorId"
            class="bg-orange-50 border border-orange-200 rounded-lg p-4 flex justify-between items-center">
            <div>
              <p class="font-medium text-orange-800">{{ t('lots.selectedSubcontractor') }}</p>
              <p class="text-sm text-orange-700">{{ subcontractorSearch }}</p>
            </div>
            <button (click)="currentLot.subcontractorId = 0; subcontractorSearch = ''"
              class="text-orange-600 hover:text-orange-800 text-sm font-medium">
              {{ t('lots.change') }}
            </button>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sticky bottom-0 bg-white border-t px-6 py-4 flex gap-3">
        <button (click)="closeModal()"
          class="flex-1 px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium">
          {{ t('common.cancel') }}
        </button>
        <button (click)="saveLot()" [disabled]="isLoading"
          class="flex-1 px-6 py-3 bg-[#FF5C02] text-white rounded-lg hover:bg-orange-600 disabled:opacity-50 flex items-center justify-center gap-2 transition-colors font-medium">
          <div *ngIf="isLoading" class="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent">
          </div>
          {{ t('lots.modal.update') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de modification de la progression -->
<div *ngIf="showProgressModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closeProgressModal()">
  <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" (click)="$event.stopPropagation()">

    <!-- En-tête -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h3 class="text-xl font-bold text-gray-900">{{ t('lots.updateProgress') }}</h3>
      <button (click)="closeProgressModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Contenu -->
    <div class="p-6">
      <!-- Messages -->
      <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
        <p class="text-red-800 text-sm">{{ errorMessage }}</p>
      </div>

      <div *ngIf="successMessage" class="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
        <p class="text-green-800 text-sm">{{ successMessage }}</p>
      </div>

      <!-- Input de progression -->
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ t('lots.progressPercentage') }}
          </label>
          <div class="flex items-center gap-3">
            <input type="number" [(ngModel)]="progressInput" min="0" max="100"
              class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              placeholder="0-100">
            <span class="text-gray-600 font-medium">%</span>
          </div>
        </div>

        <!-- Barre de prévisualisation -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ t('lots.preview') }}
          </label>
          <div class="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
            <div [style.width.%]="progressInput" class="h-full transition-all duration-300 rounded-full bg-orange-500">
            </div>
          </div>
          <p class="text-xs text-gray-500 mt-1 text-center">{{ progressInput }}%</p>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
      <button (click)="closeProgressModal()"
        class="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        [disabled]="isLoading">
        {{ t('common.cancel') }}
      </button>
      <button (click)="updateProgress()"
        class="px-4 py-2 text-white bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading || progressInput < 0 || progressInput > 100">
        <span *ngIf="!isLoading">{{ t('lots.validate') }}</span>
        <span *ngIf="isLoading" class="flex items-center gap-2">
          <svg class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          {{ t('lots.updating') }}
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Modal des commentaires -->
<div *ngIf="showCommentsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  (click)="closeCommentsModal()">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()">

    <!-- En-tête -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200">
      <h3 class="text-xl font-bold text-gray-900">{{ t('lots.commentsTitle') }}</h3>
      <button (click)="closeCommentsModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Contenu principal en deux colonnes -->
    <div class="flex-1 overflow-hidden flex flex-col md:flex-row">

      <!-- Gauche: Liste des commentaires -->
      <div class="flex-1 border-b md:border-b-0 md:border-r border-gray-200 flex flex-col">
        <div class="p-4 bg-gray-50 border-b border-gray-200">
          <h4 class="font-semibold text-gray-700">{{ t('lots.commentsHistory') }}</h4>
        </div>

        <div class="flex-1 overflow-y-auto p-4 space-y-4">
          <!-- Chargement -->
          <div *ngIf="isLoadingComments" class="flex justify-center items-center py-8">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          </div>

          <!-- Liste des commentaires -->
          <div *ngIf="!isLoadingComments && lotComments.length > 0">
            <div *ngFor="let comment of lotComments"
              class="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:border-orange-200 transition-colors">
              <div class="flex items-start gap-3">
                <!-- Avatar -->
                <div class="flex-shrink-0">
                  <div class="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
                    <span class="text-orange-600 font-semibold text-sm">
                      {{ comment.username.charAt(0).toUpperCase() }}
                    </span>
                  </div>
                </div>

                <!-- Contenu -->
                <div class="flex-1 min-w-0">
                  <div class="flex items-center justify-between mb-1">
                    <h5 class="font-semibold text-gray-900">{{ comment.username }}</h5>
                    <span class="text-xs text-gray-500">{{ formatCommentDate(comment.createdAt) }}</span>
                  </div>
                  <p class="text-gray-700 text-sm whitespace-pre-wrap">{{ comment.text }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Aucun commentaire -->
          <div *ngIf="!isLoadingComments && lotComments.length === 0" class="text-center py-12">
            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">{{ t('lots.noComments') }}</h3>
            <p class="mt-1 text-sm text-gray-500">{{ t('lots.beFirstToComment') }}</p>
          </div>
        </div>
      </div>

      <!-- Droite: Formulaire d'ajout -->
      <div class="w-full md:w-96 flex flex-col bg-gray-50">
        <div class="p-4 border-b border-gray-200">
          <h4 class="font-semibold text-gray-700">{{ t('lots.addComment') }}</h4>
        </div>

        <div class="flex-1 p-4 flex flex-col">
          <!-- Messages -->
          <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p class="text-red-800 text-sm">{{ errorMessage }}</p>
          </div>

          <div *ngIf="successMessage" class="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <p class="text-green-800 text-sm">{{ successMessage }}</p>
          </div>

          <!-- Zone de texte -->
          <div class="flex-1 flex flex-col">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ t('lots.yourComment') }}
            </label>
            <textarea [(ngModel)]="newCommentText" rows="6"
              class="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"
              [placeholder]="t('lots.commentPlaceholder')"></textarea>
          </div>

          <!-- Bouton d'envoi -->
          <button (click)="addComment()" [disabled]="isLoadingComments || !newCommentText.trim()"
            class="mt-4 w-full px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            <svg *ngIf="!isLoadingComments" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            <div *ngIf="isLoadingComments"
              class="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
            <span>{{ isLoadingComments ? t('lots.sending') : t('lots.send') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal des détails du lot -->
<div *ngIf="showDetailsModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  (click)="closeDetailsModal()">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()">

    <!-- En-tête -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
      <h3 class="text-xl font-bold text-gray-900">{{ t('lots.detailsTitle') }}</h3>
      <button (click)="closeDetailsModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Contenu -->
    <div class="p-6">
      <!-- Chargement -->
      <div *ngIf="isLoading" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>

      <!-- Détails -->
      <div *ngIf="!isLoading && selectedLotDetails" class="space-y-6">

        <!-- Informations principales -->
        <div class="bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg p-6 border border-orange-200">
          <div class="flex items-start justify-between mb-4">
            <div>
              <h4 class="text-2xl font-bold text-gray-900 mb-2">{{ selectedLotDetails.name }}</h4>
              <span
                class="bg-white px-3 py-1 rounded-full text-xs font-medium text-orange-600 border border-orange-200">
                Lot #{{ selectedLotDetails.id }}
              </span>
            </div>
            <span [class]="getStatusColorClass(selectedLotDetails.status)">
              {{ getStatusLabel(selectedLotDetails.status) }}
            </span>
          </div>
        </div>

        <!-- Description -->
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h5 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
            <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
            </svg>
            {{ t('lots.description') }}
          </h5>
          <p class="text-gray-700 whitespace-pre-wrap">{{ selectedLotDetails.description }}</p>
        </div>

        <!-- Progression -->
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h5 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
            <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            {{ t('lots.progressPercentage') }}
          </h5>
          <div class="flex items-center gap-4">
            <div class="flex-1 h-4 bg-gray-200 rounded-full overflow-hidden">
              <div [style.width.%]="selectedLotDetails.progressPercentage"
                class="h-full bg-gradient-to-r from-orange-500 to-orange-600 transition-all duration-500">
              </div>
            </div>
            <span class="text-xl font-bold text-gray-900">{{ selectedLotDetails.progressPercentage }}%</span>
          </div>
        </div>

        <!-- Dates -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white border border-gray-200 rounded-lg p-5">
            <h5 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{ t('lots.startDate') }}
            </h5>
            <p class="text-2xl font-bold text-gray-900">{{ formatDateFromAPI(selectedLotDetails.startDate) }}</p>
          </div>

          <div class="bg-white border border-gray-200 rounded-lg p-5">
            <h5 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{ t('lots.endDate') }}
            </h5>
            <p class="text-2xl font-bold text-gray-900">{{ formatDateFromAPI(selectedLotDetails.endDate) }}</p>
          </div>
        </div>

        <!-- Sous-traitant -->
        <!-- <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h5 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
            <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            {{ t('lots.assignedSubcontractor') }}
          </h5>
          <div *ngIf="selectedLotDetails?.subcontractor" class="flex items-center gap-4 bg-gray-50 rounded-lg p-4">
            <div class="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
              <span class="text-orange-600 font-bold text-lg">
                {{ (selectedLotDetails!.subcontractor.prenom || '').charAt(0).toUpperCase() }}{{
                (selectedLotDetails!.subcontractor.nom || '').charAt(0).toUpperCase() }}
              </span>
            </div>
            <div class="flex-1">
              <p class="font-semibold text-gray-900">
                {{ selectedLotDetails!.subcontractor.prenom }} {{ selectedLotDetails!.subcontractor.nom }}
              </p>
              <p *ngIf="selectedLotDetails!.subcontractor.company?.name" class="text-sm text-gray-600">
                {{ selectedLotDetails!.subcontractor.company!.name }}
              </p>
              <p class="text-sm text-orange-600 font-medium">{{ selectedLotDetails!.subcontractor.telephone }}</p>
            </div>
          </div>
          <div *ngIf="!selectedLotDetails?.subcontractor"
            class="flex items-center gap-3 bg-gray-50 rounded-lg p-4 text-gray-500 text-sm">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            {{ t('projectPresentation.noSubcontractor') }}
          </div>
        </div> -->

        <!-- Documents -->
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <div class="mb-4">
            <h5 class="font-semibold text-gray-900 flex items-center gap-2">
              <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Documents joints ({{ lotDocuments.length }})
            </h5>
          </div>

          <div *ngIf="lotDocuments.length === 0" class="text-center py-8 text-gray-500">
            <svg class="w-16 h-16 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p class="text-sm">Aucun document pour le moment</p>
          </div>

          <div *ngIf="lotDocuments.length > 0" class="space-y-2">
            <div *ngFor="let doc of pagedDocs"
              class="flex items-center justify-between bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors">
              <div class="flex items-center gap-3 flex-1 min-w-0">
                <!-- Icône du document -->
                <div class="bg-orange-100 p-2 rounded-lg flex-shrink-0">
                  <svg class="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>

                <!-- Info du document -->
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ doc.libelle || 'Document sans nom' }}</p>
                  <p class="text-xs text-gray-400 truncate">{{ doc.filePath.split('/').pop() }}</p>
                </div>
              </div>

              <!-- Boutons d'action -->
              <div class="flex items-center gap-1 ml-3">

                <!-- Bouton Télécharger -->
                <button (click)="downloadDocument(doc)"
                  class="text-green-600 hover:text-green-700 p-2 rounded-lg hover:bg-green-50 transition-colors"
                  title="Télécharger">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>

                <!-- Bouton Supprimer -->
                <button (click)="deleteLotDocument(doc.id)"
                  class="text-red-600 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors"
                  title="Supprimer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>

            </div>
            </div>

            <!-- Pagination documents -->
            <div *ngIf="docsTotalPages > 1"
              class="flex items-center justify-between pt-3 border-t border-gray-100 mt-2">
              <button (click)="previousDocsPage()" [disabled]="docsPage === 0"
                class="flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                {{ t('common.previous') }}
              </button>
              <span class="text-xs text-gray-500">
                {{ docsPage + 1 }} / {{ docsTotalPages }}
              </span>
              <button (click)="nextDocsPage()" [disabled]="docsPage >= docsTotalPages - 1"
                class="flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                {{ t('common.next') }}
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- Erreur -->
      <div *ngIf="errorMessage && !isLoading" class="p-4 bg-red-50 border border-red-200 rounded-lg">
        <p class="text-red-800 text-sm">{{ errorMessage }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="sticky bottom-0 bg-gray-50 border-t px-6 py-4">
      <button (click)="closeDetailsModal()"
        class="w-full px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
        {{ t('common.close') }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de confirmation de suppression de document -->
<div *ngIf="showDeleteDocModal"
  class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[100] p-4">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
    <!-- Icône de danger -->
    <div class="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
      <svg class="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </div>
    <h3 class="text-lg font-bold text-gray-900 mb-2">Supprimer le document</h3>
    <p class="text-sm text-gray-500 mb-6">Cette action est irréversible. Le document sera définitivement supprimé.</p>
    <div class="flex gap-3">
      <button (click)="cancelDeleteDocument()"
        class="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors">
        Annuler
      </button>
      <button (click)="confirmDeleteDocument()"
        class="flex-1 px-4 py-2.5 bg-red-600 text-white rounded-xl font-medium hover:bg-red-700 transition-colors">
        Supprimer
      </button>
    </div>
  </div>
</div>

<!-- Modal Upload Document -->
<div *ngIf="showDocumentUploadModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  (click)="closeDocumentUpload()">
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-md" (click)="$event.stopPropagation()">

    <div class="p-6 border-b border-gray-200 flex justify-between items-center">
      <h3 class="text-xl font-bold text-gray-900">Ajouter un document</h3>
      <button (click)="closeDocumentUpload()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="p-6 space-y-6">
      <div *ngIf="errorMessage" class="p-3 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
        {{ errorMessage }}
      </div>

      <!-- Libellé du document -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Libellé du document *</label>
        <input type="text" [(ngModel)]="documentLibelle"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
          placeholder="Ex: Plan de construction, Devis, etc.">
      </div>

      <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
        <input type="file" id="documentFile" class="hidden" (change)="onDocumentFileSelected($event)"
          accept=".pdf,.jpg,.jpeg,.png">
        <label for="documentFile" class="cursor-pointer">
          <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <p class="mt-2 text-sm font-medium text-gray-900">
            {{ uploadingFileName || 'Cliquez ou glissez-déposez un fichier' }}
          </p>
          <p class="mt-1 text-xs text-gray-500">PDF, PNG, JPG jusqu'à 10 Mo</p>
        </label>
      </div>

      <div *ngIf="uploadingFileName" class="text-sm text-gray-600 bg-gray-50 p-3 rounded">
        Fichier sélectionné : <strong>{{ uploadingFileName }}</strong>
      </div>
    </div>

    <div class="flex justify-end gap-3 px-6 py-4 bg-gray-50 border-t rounded-b-xl">
      <button (click)="closeDocumentUpload()" class="px-5 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50">
        Annuler
      </button>
      <button (click)="uploadDocument()" [disabled]="isUploading || !uploadingFile || !documentLibelle.trim()"
        class="px-6 py-2.5 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 flex items-center gap-2">
        <span *ngIf="isUploading"
          class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
        {{ isUploading ? 'Upload...' : 'Ajouter' }}
      </button>
    </div>
  </div>
</div>
